import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "14",
      height: "14",
      x: "1",
      y: "1",
      stroke: "currentColor",
      "stroke-width": "2",
      rx: "7"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10.5",
      height: "10.5",
      x: "2.75",
      y: "2.75",
      fill: "#fff",
      stroke: "#fff",
      "stroke-width": "1.5",
      rx: "5.25"
    }, null, -1)
  ])))
}
export default { render: render }